import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 83D0E9E7-B196-4515-A9C8-6E6FEB03ADD1
 * name hospital-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-box.svg
 * tags
 * - Medical / Hospital 
 */
export const HospitalBoxIcon = createSvgIcon(<><path d="M18,14H14V18H10V14H6V10H10V6H14V10H18M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></>, 'HospitalBoxIcon');
export default HospitalBoxIcon